// Detail pane → Team & approvals. Task Approvals used to be a conditional menu
// item; here it is always present and disabled when the workflow has none.

import { Button, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { MdApproval, MdPeople } from 'react-icons/md';
import { Chatbot } from '@/lib/sdk/chatbot/types';

interface TeamApprovalsTabProps {
  chatbot: Chatbot;
  onManageTeam: () => void;
  onReviewApprovals: () => void;
}

export function TeamApprovalsTab({
  chatbot,
  onManageTeam,
  onReviewApprovals,
}: TeamApprovalsTabProps) {
  const teamCount = chatbot.team?.length ?? 0;

  return (
    <VStack align="stretch" spacing={3} maxW="480px" data-testid="wfl-team-panel">
      <HStack
        justify="space-between"
        borderWidth="1px"
        borderColor="border-default"
        borderRadius="md"
        px={4}
        py={3}
      >
        <HStack spacing={3}>
          <Icon as={MdPeople} color="text-secondary" />
          <Text fontSize="sm" color="text-primary">
            {teamCount} team {teamCount === 1 ? 'member' : 'members'}
          </Text>
        </HStack>
        <Button size="sm" variant="outline" onClick={onManageTeam}>
          Manage team
        </Button>
      </HStack>

      <HStack
        justify="space-between"
        borderWidth="1px"
        borderColor="border-default"
        borderRadius="md"
        px={4}
        py={3}
      >
        <HStack spacing={3}>
          <Icon as={MdApproval} color="text-secondary" />
          <Text fontSize="sm" color="text-primary">
            Task approvals {chatbot.task_approvals ? 'enabled' : 'disabled'}
          </Text>
        </HStack>
        <Button
          size="sm"
          variant="outline"
          onClick={onReviewApprovals}
          isDisabled={!chatbot.task_approvals}
        >
          Review approvals
        </Button>
      </HStack>
    </VStack>
  );
}
